import { useState } from "react";

import { getCookie } from "../../utils";

declare global {
    interface Window {
        __IS_LOGGED_IN__?: boolean;
    }
}

// On SSR, trello-template.tsx injects window.__IS_LOGGED_IN__ from the HTTP
// request's idMember cookie so both SSR and client start with the same state.
// This prevents a header button color flash/switch for logged-in users.
const getInitialLoggedInState = (): boolean | undefined => {
    if (typeof window === "undefined") return undefined;
    // Use server-injected value if present (set before hydration from SSR HTML)
    if (window.__IS_LOGGED_IN__ !== undefined) return window.__IS_LOGGED_IN__;
    // Fallback: read cookie directly (covers non-SSR static mode)
    return getCookie("idMember") ? true : false;
};

export const useIsLoggedIn = () => {
    const [isLoggedIn] = useState<boolean | undefined>(getInitialLoggedInState);
    return isLoggedIn;
};
